module.exports = __webpack_public_path__ + "img/business.01aedf3a.svg";